import { render, staticRenderFns } from "./communityMiniList.vue?vue&type=template&id=51a5ec1e&scoped=true"
import script from "./communityMiniList.vue?vue&type=script&lang=js"
export * from "./communityMiniList.vue?vue&type=script&lang=js"
import style0 from "./communityMiniList.vue?vue&type=style&index=0&id=51a5ec1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a5ec1e",
  null
  
)

export default component.exports